import { render } from "./BuyMethItem.vue?vue&type=template&id=202b819c"
import script from "./BuyMethItem.vue?vue&type=script&lang=js"
export * from "./BuyMethItem.vue?vue&type=script&lang=js"

import "./BuyMethItem.vue?vue&type=style&index=0&id=202b819c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__